import { createLoadingAction, createRunMutationAction } from '@/store/utils';
import * as types from '@/store/spFreelancerRegistration/actionTypes';
import * as mutationTypes from '@/store/spFreelancerRegistration/mutationTypes';
// eslint-disable-next-line import/no-cycle
import {
  loadServices, loadCertificates, registerSPUser,
} from '@/services/repository';

export default {
  [types.CHANGE_SP_FREELANCER_FORTH_STEP_REGISTRATION_VALID]: createRunMutationAction(mutationTypes.SET_SP_FREELANCER_REGISTRATION_FORTH_STEP_VALID),
  [types.CHANGE_SP_FREELANCER_RECOMMENDATION_INFO]: createRunMutationAction(mutationTypes.SET_SP_FREELANCER_RECOMMENDATION_INFO),
  [types.CHANGE_SP_FREELANCER_SOCIAL_NETWORK_LINK_INFO]: createRunMutationAction(mutationTypes.SET_SP_FREELANCER_SOCIAL_NETWORK_LINK_INFO),
  [types.CHANGE_SP_FREELANCER_IP_ADDRESS_INFO]: createRunMutationAction(mutationTypes.SET_SP_FREELANCER_IP_ADDRESS_INFO),
  [types.CHANGE_SP_FREELANCER_COMPANY_CERTIFICATION]: createRunMutationAction(mutationTypes.SET_SP_FREELANCER_COMPANY_CERTIFICATION),
  [types.CHANGE_SP_FREELANCER_SERVICES_INFO]: createRunMutationAction(mutationTypes.SET_SP_FREELANCER_SERVICES_INFO),
  [types.CHANGE_SP_FREELANCER_AVATAR]: createRunMutationAction(mutationTypes.SET_SP_FREELANCER_CLIENT_AVATAR),
  [types.CLEAN_SP_FREELANCER_REGISTRATION_DATA]: createRunMutationAction(mutationTypes.REMOVE_SP_FREELANCER_REGISTRATION_DATA),
  [types.CHANGE_SP_FREELANCER_REGISTRATION_CURRENT_STEP]: createRunMutationAction(mutationTypes.SET_SP_FREELANCER_REGISTRATION_CURRENT_STEP),
  [types.CHANGE_SP_FREELANCER_CLIENT_REGISTRATION_DATA]: createRunMutationAction(mutationTypes.SET_SP_FREELANCER_CLIENT_REGISTRATION_DATA),
  [types.CHANGE_SP_FREELANCER_EMAIL_VERIFICATION_INFO]: createRunMutationAction(mutationTypes.SET_SP_FREELANCER_EMAIL_VERIFICATION_INFO),
  [types.CHANGE_SP_FREELANCER_REGISTRATION_RECAPTCHA_TOKEN]: createRunMutationAction(mutationTypes.SET_SP_FREELANCER_REGISTRATION_RECAPTCHA_TOKEN),
  [types.CHANGE_SP_FREELANCER_REGISTRATION_FILLED_STEPS_COUNT]: createRunMutationAction(
    mutationTypes.SET_SP_FREELANCER_REGISTRATION_FILLED_STEPS_COUNT,
  ),
  [types.CHANGE_SP_FREELANCER_REGISTRATION_VISITED_STEPS_COUNT]: createRunMutationAction(
    mutationTypes.SET_SP_FREELANCER_REGISTRATION_VISITED_STEPS_COUNT,
  ),
  [types.LOAD_SERVICES]: createLoadingAction({
    method: loadServices,
    dataKey: 'spFreelancerServices',
    settingDataMutation: mutationTypes.SET_SERVICES,
    settingLoadingMutation: mutationTypes.SET_SP_FREELANCER_SERVICES_INFO_LOADING,
    settingErrorMutation: mutationTypes.SET_SP_FREELANCER_SERVICES_INFO_LOADING_ERRORS,
  }),
  [types.LOAD_CERTIFICATES]: createLoadingAction({
    method: loadCertificates,
    dataKey: 'spFreelancerCertificates',
    settingDataMutation: mutationTypes.SET_CERTIFICATES,
    settingLoadingMutation: mutationTypes.SET_SP_FREELANCER_CERTIFICATES_INFO_LOADING,
    settingErrorMutation: mutationTypes.SET_SP_FREELANCER_CERTIFICATES_INFO_LOADING_ERRORS,
  }),
  async [types.REGISTER_SP_FREELANCER]({ getters }) {
    const {
      lastName,
      jobTitle,
      firstName,
      phoneNumber,
    } = getters.spFreelancerRegistrationClientInfo;
    const {
      workEmail,
      password,
    } = getters.spFreelancerRegistrationEmailVerificationInfo;
    const {
      yearsOfExperience,
      servicesChosen,
    } = getters.spFreelancerServicesInfo;

    const userData = {
      emailVerificationInfo: {
        workEmail,
        password,
      },
      clientInfo: {
        firstName,
        lastName,
        jobTitle,
        phoneNumber,
      },
      servicesInfo: {
        yearsOfExperience,
        servicesChosen,
      },
      certificationInfo: {
        certificationData: getters.spFreelancerRegistrationCompanyCertificationInfo,
        socialMediaLinks: getters.spFreelancerRegistrationCompanySocialNetworkLinkInfo,
        ipAddress: getters.spFreelancerRegistrationCompanyIpAddressInfo.ipAddress,
        recommendationsInfo: getters.spFreelancerRegistrationCompanyRecommendationInfo.recommendations,
      },
      avatar: getters.registrationClientAvatar,
      recaptchaToken: getters.spFreelancerRegistrationRecaptchaToken,
    };
    const result = await registerSPUser(userData);
    return result;
  },
};
